<template>
  <div class="container">
    <div :class="{content: true,empty: list.length === 0}">
      <!-- <div :class="['clueList','myClue','top','nearTop']">
        <div class="nav">
          <li v-for="(f, i) in filters" :key="i">
            <div class="status">
              <label>{{f.title}}</label>
              <span :class="{active: s.selected}" v-for="(s, si) in f.list" @click="choseStatus(s, f)" :key="si">{{s.title}}</span>
            </div>
          </li>
        </div>
      </div> -->
      <div class="screen">
        <div class="mb10 public" v-for="(items, index) in filters" :key="index">
          <ul>
            <label>{{items.title}}</label>
            <li :class="{showSelect : items.expand}" :ref="`filter${index}`">
              <span :class="{active: item.selected}" v-for="(item, index) in items.list" :key="index" @click="selectItem(item, items)">{{item.title}}</span>
            </li>
            <li class="btn" v-if="items.list.length > 10">
              <button @click="showSelect(items, `filter${index}`)" class="down">
                <img :src="items.expand ? icons.upward : icons.downward" alt="icon">
              </button>
            </li>
          </ul>
          <ul v-for="(c, i) in items.list" v-show="c.selected && c.list && c.list.length > 0" :key="i">
            <label>{{c.title}}</label>
            <li :class="{showSelect : c.expand}" :ref="`filterson${index}_${i}`">
              <span :class="{active: ci.selected}" v-for="(ci, cd) in c.list" :key="cd" @click="selectItem(ci, c)">{{ci.title}}</span>
            </li>
            <li class="btn" v-if="c.list && c.list.length > 0 && calWidth('filterson'+index+'_'+i,c.list)">
              <button @click="showSelect(c, `filterson${index}_${i}`)" class="down">
                <img :src="c.expand ? icons.upward : icons.downward" alt="icon">
              </button>
            </li>
          </ul>
          
        </div>
        <div class="mb10 public">
          <ul>
            <label>状态</label>
            <li>
              <span :class="{active: i == typeIndex}" v-for="(d, i) in typeList.list" :key="i" @click="selectDay(i)">{{d.title}}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 报道审核、我的报道样式 -->
      <div :class="['clueList','on',list.length === 0 ? 'empty': '']">
        <div class="nav on">
          <li class="upload creat" v-if="showCreate">
            <button @click="goCreate()">{{`新建${$_syscfg.publish}`}}</button>
          </li>
        </div>
        <div class="list">
          <empty :mTop="30" v-if="list && list.length === 0 && !waiting" :msg="`暂无${$_syscfg.publish}数据`" />
          <skeleton v-show="waiting"></skeleton>
          <ul v-show="!waiting" v-for="(item, index) in list" :key="index">
            <!-- <label @click="selectOne(item)"><img :src="item.selected ? icons.checkerOn : icons.checker" class="checker" alt="checker"></label> -->
            <img v-if="item.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
            <div v-if="item.status != 0" class="thumImg" :style="'background: url('+ item.cover +') no-repeat;'" @click="viewMedia(item)">
              <div v-show="isChrome" class="backDrop"></div>
              <div v-show="!isChrome" :style="'background: url('+ item.cover +') no-repeat;'" class="blur"></div>
              <p class="tags" v-if="item.has_avid_icon || item.has_kankan_icon || item.has_iditor_icon">
                <img v-if="item.has_avid_icon" src="@assets/img/index/tv.svg" alt="tv">
                <img v-if="item.has_kankan_icon" src="@assets/img/index/kankan.svg" alt="kankan">
                <img v-if="item.has_iditor_icon" src="@assets/img/index/dxgg.svg" alt="dxgg">
              </p>
              <img @error="imgError(item)" class="cover" :src="item.img_url || item.cover || defaultImg" alt="img">
              <img v-if="item.play_icon - 0 === 1 && item.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
            </div>
            <div v-if="item.status == 0" class="bothImg" @click="viewMedia(item)">
              <div :style="'background: url('+ item.cover +') no-repeat;'">
                <div v-show="!isChrome" :style="'background: url('+ item.cover +') no-repeat;'" class="blur"></div>
                <div v-show="isChrome" class="backDrop"></div>
                <img @error="imgError(item)" class="cover" :src="item.img_url || item.cover || defaultImg" alt="img">
                <img v-if="item.play_icon - 0 === 1 && item.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
              </div>
              <img class="default" :src="defaultImg" alt="">
            </div>
            <dl>
              <a @click="handleGo(item)">
                <h4 :class="{news: item.is_new == 1}">
                  <span @mouseenter="showHistory(index)" @mouseout="closeHistory(index)" :class="{statusTag: true, greenTag: item.status == 0 || item.status == 5 || item.status == 2 || item.status == 1, redTag: item.status == 3 || item.status == 4 || item.status == 7}"
                    v-if="item.status_name">{{item.status_name}}</span>
                  <span class="title" :title="item.title">
                    {{item.title}}
                  </span>
                  <img src="@assets/img/common/tips.svg" alt="change" v-if="item.has_change - 0 === 1">
                  <img src="@assets/img/common/new.svg" alt="new" v-if="item.is_new - 0 === 1">
                  <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="item.has_img - 0 === 1">
                  <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="item.has_video - 0 === 1">
                  <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="item.has_sound - 0 === 1">
                  <!-- todo 22 -->
                  <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="item.has_audit&&item.has_audit==2" src="@assets/img/common/verify-fail.svg">
                </h4>
                <li>{{item.content}}</li>
                <div v-show="item.showHistory" :style="'width:'+errWidth+'px'" class="articleStatus-container">
                  <div class="proceeding-container">
                    <p :style="'width:'+itemprogress+'%'" class="proceeding"></p>
                    <ul>
                      <li :class="{green: item.color == 'green', red: item.color == 'red'}" :style="'left:'+item.left+'%'" v-for="(item,index) in historyList.arr" :key="index">
                        <i></i>
                        <p>{{item.name}}</p>
                      </li>
                    </ul>
                  </div>

                  <div v-if="false" class="time green">
                    <i></i>
                    <span>2019-03-24  12:30:00</span>
                  </div>

                  <div class="messageList">
                    <div v-for="(item,index) in historyList.list" :key="index">
                      <p class="type">{{item.msg}}</p>
                      <p class="t">{{item.raw_add_time}}</p>
                      <p class="a">{{item.user_name}}</p>
                      <p :class="{s: true, red: item.color == 'red', green: item.color == 'green'}">{{item.type_name}}</p>
                    </div>
                  </div>
                </div>
              </a>
              <li class="smal">
                <span>{{item.user_name}}</span>
                <span>{{item.add_time}}</span>
                <span v-if="item.column" class="publish">
                  {{`${item.column}`}}
                </span>
                <!-- <span class="publish" v-for="(c,i) in item.column" :key="i">
                  {{`${c.ftitle ? c.ftitle : ""} ${c.stitle ? c.stitle : ""  } ${c.ttitle ? c.ttitle : ""}`}}
                </span> -->
              </li>
            </dl>
            <!-- 我的发布 -->
            <div class="doubleCreat">
              <div class="line">
                <button class="success" v-if="item.platform_key == 'dy' && item.status == 5 && item.has_dy_btn == 1" @click="toDy(item.id, index)">推抖音</button>
                <button v-if="item.has_copy" class="success" @click="copyReport(item.id,index)">转发</button>
                <button v-if="item.has_edit" @click="handleGo(item)">编辑</button>
                <button v-if="item.has_view && item.status != 4" @click="reviewMedia(item,index)">预览</button>
                <button v-if="item.has_resend" @click="resend(item.id)">重新发布</button>
                <button v-if="item.has_share && item.status == 1 && item.status != 5" @click="$MediaPlatformShare(item.id)">分享链接</button>
                <button v-if="item.has_del" @click="deleteItem(item)">删除</button>
                <div v-if="item.status == 1 || item.status == 4 || item.status == 5" :data-index="index" class="moreBtn">
                  <div class="tb">
                    <i></i>
                  </div>
                  <div class="btn">
                    <span></span>
                    <ul class="authBtnList">
                      <li v-if="item.has_view && item.status != 1 && item.status != 5" @click="reviewMedia(item)">预览</li>
                      <li v-if="item.has_share && item.status != 1" @click="$MediaPlatformShare(item.id)">分享链接</li>
                      <li v-if="item.has_stream_send" @click="mediaSend(item.id, index)">归档</li>
                      <li v-if="item.has_cancel" @click="newMediaCancel(item.id)">撤回</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
    <pushBox ref="pushBox" />
    <checkers ref="checkers" />
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import pages from "@components/pages";
import pushBox from "@components/pushBox";
import checkers from "@components/checkers";
import empty from "@components/empty";
import skeleton from "@components/skeleton";
import vClickOutside from "v-click-outside";
import Vue from "vue";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { pages, pushBox, checkers, empty, skeleton },
  data() {
    return {
      controller: null,
      errWidth: 584,
      itemprogress: 0,
      typeList: [],
      waiting: true,
      isXnew: this.$store.state.isXnew,
      list: [],
      defaultImg: require("@assets/img/common/default.png"),
      page: {
        pageCount: 0,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      allSelected: false,
      backShow: false,
      pushBox: false,
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg")
      },
      filters: [],
      filterOptions: {},
      searchOptions: {},
      showCreate: false,
      typeKey: '',
      typeIndex: 0,
      historyList: {},
      isChrome: true
    };
  },
  methods: {
    calWidth(filter,list) {
      if(list.length > 0) {
        // console.log(12345,filter,this.$refs[filter])
        if(this.$refs[filter]){
          let width = this.$refs[filter][0].getBoundingClientRect().width;
          let w = 0
          if(this.$refs[filter][0].children.length > 0){
            for(let i = 0; i < this.$refs[filter][0].children.length; i++){
              w+=this.$refs[filter][0].children[i].getBoundingClientRect().width
            }
          }

          // console.log(w,width)

          if(w > width){
            return true
          }
          // console.log(width, w)
        }
      }
      
    },
    toDy(id) {
      this.$dyScan(id).then(res => {
        if(res){
          this.getList();
        }
      })
    },
    mediaSend(id, index) {
      // console.log(index)
      this.list[index].showMoreBtn = false;
      let info = {
          subject_type: 5,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    async newMediaCancel(id) {
      // let confirm = {};

      
      // let msg = `撤回该发布？`;

      // confirm.status = await this.$confirm(msg);
      // confirm.isSelected = 0;
        
      // if (!confirm.status) return;

      this.$tipsBox().then(res => {
        if(res){
          // console.log(res)
          let info = {
            id: id
          }

          common.myFetch(apis.newMediaCancel, info).then(r => {
            if (r) {
              // console.log(r)
              this.$toast(r)
              this.getList()
            }
          });
        }
      })
    },
    showHistory(i) {
      this.list[i].showHistory = true

      const info = {
        id: this.list[i].id
      };

      common.myFetch(apis.newMediaPlatformMyHistory, info).then(r => {
        if (r) {
          console.log(r)
          let arr = []
          for(let key in r.points){
            if(r.points[key].exist) {
              arr.push({
                name: r.points[key].desc,
                color: r.points[key].color
              })
            }
          }

          if(arr.length > 8){
            this.errWidth = arr.length * 73
          }else{
            this.errWidth = 584
          }

          if (arr.length > 2){
            let length = arr.length - 1
            let gap = 100 / length
            let init = 0
            let i = 0
            arr.forEach(el => {
              el.left = init * gap
              if(el.color == 'green'){
                i = init
              }
              init ++
            })
            arr[length].left = 98;
            this.itemprogress = i * gap
          }else if(arr.length == 2){
            arr[0].left = 0;
            arr[1].left = 97;
            if(arr[1].color == 'green'){
              this.itemprogress = 100
            }
          }else if(arr.length == 1){
            arr.push({
              name: '发布',
              color: 'white'
            })
            arr[0].left = 0;
            arr[1].left = 97;
            this.itemprogress = 0
          }

          r.arr = arr
          this.historyList = r
          // console.log(arr)
        }
      });
    },
    closeHistory(i) {
      this.list[i].showHistory = false
    },
    showSelect(i, key) {
      // 展开／关闭收起某类
      this.$set(i, "expand", !i.expand);

      this.$nextTick(() => {
        this.$set(this.expandedFilters, i.key, i.expand);

        if (!i.expand) {
          this.$refs[key][0].scrollTop = 0;
        }
      });
    },
    selectDay(d) {
      console.log(d)
      this.page.pageIndex = 1;
      this.typeIndex = d;
      this.typeKey = this.typeList.list[d].id
      this.calculatefitlers();
    },
    selectItem(i, l) {
      // 选择／反选 过滤项
      this.page.pageIndex = 1;

      this.$set(i, "selected", !i.selected);
      this.calculatefitlers();
    },
    calculatefitlers() {
      // 整理过滤项为接口格式，请求接口
      // this.filters.forEach(f => {
      //   let _this = this;
      //   const ids = f.list
      //     .map(i => {
      //       let that = _this;
      //       if (i.selected) {
      //         if (!i.list || i.list.length === 0) {
      //           return i.id;
      //         } else {
      //           let _that = that;
      //           const allId = i.list
      //             .map(c => {
      //               if (c.selected) {
      //                 return c.id;
      //               }
      //             })
      //             .filter(k => k)
      //             .join(",");
      //           _that.filterOptions[i.key] = allId || "";
      //           return i.id;
      //         }
      //       }
      //     })
      //     .filter(j => j)
      //     .join(",");
      //   this.filterOptions[f.key] = ids || "";
      // });

      this.filters.forEach(i => {
        const selected1 = [] // 一级已选
        let selected2 = [] // 二级已选
        let key2 = ''
        i.list.forEach(c => {
          if (c.selected) {
            selected1.push(c.id || c.key)
          }

          if (c.list) {
            const subSelected = []
            key2 = c.key
            c.list.forEach( s => {
              if (s.selected) {
                subSelected.push(s.id)
              }
            })
            selected2 = selected2.concat(subSelected)
          }
        })

        this.filterOptions[i.key] = selected1.join(',')
        if (key2) this.filterOptions[key2] = selected2.join(',')
      })

      this.addTimeData();
      this.getList();
    },
    addTimeData(n) {
      const timeObj = {
        status: this.typeKey
      };
      Object.assign(this.filterOptions, timeObj);
    },
    resend(id) {
      const info = {
        id: id
      };

      common.myFetch(apis.newMediaPlatformMyResend, info).then(r => {
        if (r) {
          this.$toast(r)
        }
      });
    },
    deepCopy(obj) {
      // 判断传入的值是否为一个对象
      if (obj === null && typeof obj !== "object") {
        return obj;
      }
      // 判断对象的类型 注意这里不考虑包装类对象
      if (Object.prototype.toString.call(obj) === "[object Date]") {
        return new Date(obj);
      }
      if (Object.prototype.toString.call(obj) === "[object RegExp]") {
        return new RegExp(obj);
      }
      if (Object.prototype.toString.call(obj) === "[object Undefined]") {
        return new Error(obj);
      }
      // 判断对象是类
      let newObj = Array.isArray(obj)  ? [] : {}
      for(let item in obj){
        if(typeof obj[item] === 'object') {
            newObj[item] = this.deepCopy(obj[item])
        }else {
            newObj[item] = obj[item]
        }
      }
      return newObj
    },
    reviewMedia(item, index) {
      if(item.platform_key == 'new_media_knews' || item.platform_key == 'five_star_sports_cms'){
        this.$PreviewKnews(item.id)
      }else if(item.platform_key == 'bilibili'){
        this.$PreviewBili(item.id)
      }else{
        // this.list[index].showThreePoint = false;
        let res = this.deepCopy(item)
        res.platformType = res.platform_key
        res.content = res.content_html
        this.$PreviewBox(res)
      }
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "img_url", this.defaultImg);
    },
    async copyReport(id, index) {
      // 复制报道
      const type = await this.$MediaPlatform('copy');
      if (!type) return;
      this.list[index].showMoreBtn = false;
      const info = {
        id: id,
        platforms: type
      };

      const newWindow = window.open();

      common.myFetch(apis.newMediaPlatformMyCopy, info).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/editMediaPublish?d=${r.report_id}`;
        }
      });
    },
    goViewLink(i) {
      if (i.url) {
        window.open(i.url);
      }
    },
    async viewMedia(item) {
      let list = await common.myFetch(apis.File_status, {
        subject_id: item.id,
        subject_type: 5
      })
      common.openMaterialBox(list, null, false);
    },
    //送审
    async toCheck(id) {
      const info = {
        id: id
      };

      common.myFetch(apis.publishAddverify, info).then(r => {
        if (r) {
          this.$toast(r);
          this.getList();
        }
      });
    },
    async publish(id) {
      // 发布
      const info = {
        id: id
      };
      common.myFetch(apis.Rpb_release, info).then(res => {
        if (res) {
          this.$toast(`${res.msg_one}，${res.msg_two}`);

          this.getList();
        }
      });
    },
    async deleteItem(i) {
      let confirm = {};

      
        let msg = `删除该发布？`;

        confirm.status = await this.$confirm(msg);
        confirm.isSelected = 0;
        
      if (!confirm.status) return;

      const info = {
        id: i.id
      };

      common.myFetch(apis.newMediaPlatformMyDel, info).then(r => {
        if (r) {
          this.$toast(r);
          this.getList();
        }
      });
    },
    selectAll() {
      // 全选／反选
      const pushlist = this.list.filter(l => {
        if (l.has_push) {
          return l;
        }
      });

      this.allSelected = !this.allSelected;

      pushlist.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });

      if (pushlist.length !== this.page.pageSize) {
        let msg = "已选中有发送权限的条目";
        if (pushlist.length === 0) {
          msg = "暂无可发送的条目";
        }

        this.$toast(msg);
        this.allSelected = false;
      }
    },
    selectOne(i) {
      // 选择／反选
      if (!i.has_push) {
        this.$toast("无发送权限，无法选中");
        return;
      }

      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    },
    getViewNum(info) {
      // 异步读取浏览数据并赋值
      common.myFetch(apis.Rpt_viewnum, info).then(r => {
        if (r) {
          const viewData = r.list;

          this.list.forEach(i => {
            if (viewData[i.idstring]) {
              this.$set(i, "view_num", viewData[i.idstring].count);
              this.$set(i, "link", viewData[i.idstring].url);
            }
          });
        }
      });
    },
    getList(keyWord) {
      if (this.controller) {
        this.controller.abort(); // 终止之前的请求
      }

      this.controller = new AbortController(); // 创建新的 AbortController
      const signal = this.controller.signal; // 获取信号

      this.waiting = true;
      const id = this.$route.params.id;
      let info = {
        idstring: id,
        search_option: "",
        key_words: "",
        status: "",
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      };

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions);

      common
        .myFetch(apis.newMediaPlatformMyList, {data: info,signal: signal})
        // common.myFetch(apis.myreport, info)
        .then(res => {
          this.allSelected = false;
          res.list.forEach(el => {
            el.showMoreBtn = false;
            el.showHistory = false;
            el.showThreePoint = false;
          })
          this.list = res.list;
          // const info = {
          //   time_start: res.time_start,
          //   time_end: res.time_end
          // }
          // this.getViewNum(info)
          // this.filters = res.params.list_search;
          
          res.params.list_search.forEach(el => {
            if(el.key == "status"){
              // console.log(el)
              this.typeList = el
            }
          })
          this.filters = res.params.list_search.filter(
            i => i.key != "status"
          );
          // console.log(this.filters)
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          this.showCreate = res.has_add_role;
          // this.showCreate = true

          this.$nextTick(() => {
            this.waiting = false;
          })
        });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    choseStatus(i, l) {
      // 选择筛选项
      if (i.selected) return;

      this.page.pageIndex = 1;

      l.list.forEach(li => {
        li["selected"] = false;
      });

      this.$set(i, "selected", true);
      this.filterOptions[l.key] = i.key;
      this.getList();
    },
    async goCreate() {
      const type = await this.$MediaPlatform();
      if (!type) return;

      common.jump(`/createMediaPublish?d=${type}`, true);
    },
    handleGo(i) {
      const s = i.status;
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);
      console.log(123)
      if (s == 0 || s == 3 || s == 6 || s == 7) {
        this.goEdit(i.id);
      } else if (s == 1 || s == 2 || s == 4 || s == 5) {
        this.goDetail(i.id);
      }
    },
    async goEdit(id) {
      const newWindow = window.open();
      common.checkPageStatus(id, 5).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editMediaPublish?d=${id}`;
        } else {
          newWindow.close();
        }
      });
    },
    goDetail(id) {
      common.jump(`/mediaPublishDetail?d=${id}`, true);
    },
    push(id) {
      this.$refs.pushBox.open(id);
    }
  },
  beforeDestroy() {
    this.$AiMessage(true)
  },
  mounted() {
    var agent = navigator.userAgent.toLowerCase();
    if(agent.indexOf("chrome") > 0) {
      this.isChrome = true
    }else{
      this.isChrome = false
    }
    this.defaultImg = this.$_syscfg.default_img
    this.getList('noKeyWord');
    this.$AiMessage()
    // this.$MediaPlatform()
  }
};
</script>

<style src="@assets/css/mediaPublish/myPublish.less" lang="less" scoped>
</style>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  
  .doubleCreat {
    .moreBtn {
      position: relative;
      margin: 0 0 0 5px;
      .tb {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        background: #FFF;
        border-radius: 4px;
        box-shadow: 2px 2px 8px 0 rgba(0,0,0,0.1);

        i {
          display: block;
          width: 16px;
          height: 4px;
          background: url('../../assets/img/mediaPublish/threeBtn.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
        }
      }

      &:hover {
        .btn {
          display: flex;
        }
      }

      .btn {
        position: absolute !important;
        top: 30px;
        right: 0px;
        z-index: 99;
        display: none;
        flex-direction: column;

        span {
          width: 78px;
          height: 6px;
        }
      }

      .authBtnList {
        display: flex;
        flex-direction: column;
        width: 70px;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px;
        background: rgba(5,15,15,0.8);
        padding: 0 !important;
        border: none !important;
        box-sizing: border-box;

        &:hover {
          background: rgba(5,15,15,0.8) !important;
        }

        li {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 13px;
          color: #FFFFFF;
          user-select: none;
          cursor: pointer;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
          }
        }
      }
    }
  }

  .thumImg {

    background-position: center center !important;
    background-size: 100% 100% !important;

    .blur {
      width: 100%;
      height: 100%;
      filter: blur(5px);
      background-position: center center !important;
      background-size: 100% 100% !important;
    }

    .backDrop {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(5px);
  }
    .cover {
          position: absolute;
          top: 0;
          left: 0;
          object-fit: contain !important;
          background-color: transparent;
    }
  }

  .bothImg {

    .blur {
      width: 100%;
      height: 100%;
      filter: blur(5px);
      background-position: center center !important;
      background-size: 100% 100% !important;
    }

    &>div {
      background-position: center center !important;
      background-size: 100% 100% !important;
    }
    
    .backDrop {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(5px);
      border-radius: 4px;
      overflow: hidden;
    }
    .cover {
          position: absolute;
          top: 0;
          left: 0;
          object-fit: contain !important;
          background-color: transparent;
          border-radius: 4px;
          overflow: hidden;
    }
  }

  .statusTag {
    min-width: 52px !important;
    padding: 0 5px;
    box-sizing: border-box;

    &.redWidth {
      min-width: 64px !important;
    }
  }
  //筛选
    .container {
      .clueList {
        .nav {
          &.on {
            padding-top: 15px !important;
            padding-bottom: 15px !important;
            box-sizing: border-box;
          }
        }
      }
    } 
    .screen {
      background: @bg;
      box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
      border-radius: 4px;
      padding: 20px 30px;
      margin-bottom: 29px;
      .line {
        height: 1px;
        width: 100%;
        background-color: @border;
        margin: 10px 0 20px;
      }

      .mb10 {
        margin-bottom: 10px;
      }

      dl {
        display: flex;
        color: @sub;
        font-size: 13px;
        
        label {
          width: 52px;
          height: 30px;
          line-height: 30px;
          margin-right: 10px;
          flex-shrink: 0;
          font-weight: bold;
        }
        .filter {
          border: 1px solid @dc;
          border-radius: 2px;
          width: 120px;
          height: 28px;
          font-size: 14px;
          color: @sub;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          background-color: rgba(185, 195, 195, 0.2);
        }
        .list {
          display: flex;
          flex: 1;
          flex-wrap: wrap;
          .subList,
          li {
            display: inline-block;
            max-width: 200px;
            height: 30px;
            line-height: 30px;
            background: rgba(@dateColor, 0.2);
            border-radius: 4px;
            padding: 0px 30px 0 10px;
            margin-right: 10px;
            margin-bottom: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            position: relative;

            i {
              display: block;
              width: 11px;
              height: 11px;
              background: url("../../assets/img/evaluating/exit.png") no-repeat;
              background-size: 100%;
              position: absolute;
              right: 9px;
              top: 0px;
              bottom: 0px;
              margin: auto;
              cursor: pointer;
            }
          }
        }
      }
      ul {
        display: flex;
        color: @sub;
        font-size: 13px;
        margin-bottom: 10px;

        &:last-child {
          margin: 0px;
        }
        label {
          color: @green;
          font-weight: bold;
          min-width: 52px;
          height: 30px;
          line-height: 30px;
          margin-right: 30px;
          text-align: justify;
          word-break: keep-all;
          // white-space: nowrap;
          // text-align-last: justify;
          &.public {
            max-width: 52px;
          }

          &::after {
            content: "";
            display: inline-block;
            padding-left: 100%;
          }
        }
        li {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          display: flex;
          flex-wrap: wrap;
          overflow: hidden;
          flex: 1;
          span {
            min-width: 80px;
            padding: 0 8px;
            height: 30px;
            line-height: 30px;
            border-radius: 100px;
            margin-right: 10px;
            text-align: center;
            cursor: pointer;
            &.active {
              height: 28px;
              line-height: 28px;
              border: 1px solid @green;
              color: @green;
            }
          }
          &.btn {
            flex: 0 40px;
            justify-content: flex-end;

            button {
              border: 1px solid @dc;
              border-radius: 2px;
              width: 33px;
              height: 30px;
              font-size: 14px;
              color: @sub;
              background: none;
              margin-left: 8px;

              // &.down{
              //     width: 33px;
              //     margin: 0px;
              //     background: url('../../img/common/xiala.svg') no-repeat;
              //     background-position: center;
              // }
              &.setting {
                background: rgba(185, 195, 195, 0.2);
              }
              &:hover {
                .btnHover;
              }
              &:active {
                .btnActive;
              }
            }
          }
          &.showSelect {
            // height: auto;
            overflow-y: auto;
            margin-bottom: -10px;
            // max-height: 130px;
            // max-height: 80px;
            height: auto;
            span {
              margin-bottom: 10px;
            }
          }
          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 2px;
          }
        }
      }
    }

    .articleStatus-container {
      position: absolute;
      z-index: 9999;
      top: 60px;
      left: 126px;
      min-width: 584px;
      background: rgba(5,15,15,0.8);
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;

      .proceeding-container {
        position: relative;
        width: 100%;
        height: 2px;
        background: #EEEEEE;
        border-radius: 6px;
        margin-top: 8px;
        margin-bottom: 60px;

        .proceeding {
          width: 0%;
          height: 100%;
          background: @green;
        }

        ul {
          border: none !important;
          padding: 0 !important;

          li {
            position: absolute;
            top: -9px;
            left: 0;
            display: flex !important;
            justify-content: center;
            align-items: center;
            width: 18px;
            height: 18px;
            background: #FFF;
            border-radius: 50%;
            margin: 0 !important;
            overflow: unset !important;

            &:nth-of-type(1) {
              p {
                left: 0;
              }
            }

            &:nth-last-of-type(1) {
              p {
                text-align: right;
                left: -22px;
              }
            }

            p {
              position: absolute;
              top: 26px;
              left: -8px;
              font-size: 16px !important;
              font-weight: bold;
              color: #CCCCCC;
              line-height: 24px;
              min-width: 40px !important;
            }

            &.green {
              p {
                color: #41B48C;
              }
              
              i {
                background: #41B48C;
              }
            }

            &.red {

              p {
                color: #FF555A;
              }
              
              i {
                background: #FF555A;
              }
            }

            i {
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #CCCCCC;
            }
          }
        }
      }

      .time {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 19px;

        &.green {
          color: #41B48C;

          i {
            display: block;
            width: 18px;
            height: 18px;
            background-image: url('../../assets/img/mediaPublish/greenClock.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;
          }
        }

        &.red {
          color: #FF555A;

          i {
            display: block;
            width: 18px;
            height: 18px;
            background-image: url('../../assets/img/mediaPublish/redClock.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;
          }
        }
      }

      .messageList {
        display: flex;
        flex-direction: column;
        width: 100%;

        & > div {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          font-size: 14px;
          margin-bottom: 12px;
          line-height: 20px;
          color: #B9C3C3;

          &:nth-last-of-type(1) {
            margin-bottom: 0 !important;
          }

          .type {
            flex: 1;
            font-weight: bold;
            color: #FFFFFF;
          }
          .t {
            width: 150px;
          }

          .a {
            width: 56px;
            text-align: right;
          }

          .s {
            width: 112px;
            text-align: right;
          }

          .red {
            color: #FF555A;
          }

          .green {
            color: #41B48C;
          }
        }
      }
    }
</style>
